import { reactive } from 'vue';

export const criarAtividade = () => {
    return reactive({
        id: 0,
        idep: 0,
        cdatividade: 0,
        nmatividade: '',
        cnae: '',
        plaexpedicao_subtipo: '',
        plaleite_subtipo: '',
        plamel_subtipo: '',
        plamp_subtipo: '',
        plaproducao_subtipo: '',
        obs: '',
        ativo: 'S',
        ckmpleite: 'N',
        ckmpmel: 'N',
        tpproduto_mapa: '',
        idlogin: 0,
        idusuario: 0
    });
}